import * as React from "react";
import { useTransition } from "react-spring";

// style, design
import * as SC from "./styles";
import newContractIcon from "../../../assets/svg/add_contract.svg";
import existingContractIcon from "../../../assets/svg/existing_contract.svg";
import copyIcon from "../../../assets/svg/material/copy_black.svg";

export default function ExistingOrNewContract({
  isOpen,
  onClose,
  onSelect,
  description,
  canClone = false, // clone option available
}) {
  const modalTransition = useTransition(!!isOpen, {
    config: { duration: 150 },
    from: { opacity: 0, transform: `translateY(100%)` },
    enter: { opacity: 1, transform: `translateY(0)` },
    leave: { opacity: 0 },
  });

  return modalTransition(
    (styles, open) =>
      open && (
        <SC.BackDrop onClick={onClose} style={{ opacity: styles.opacity }}>
          <SC.Modal
            onClick={(e) => e.stopPropagation()}
            style={{ ...styles, opacity: 1 }}
          >
            <SC.ModalContent>
              <SC.ModalTitle style={{ marginBottom: "12px" }}>
                {description ||
                  "Välj om det är ett existerande eller nytt avtal"}
              </SC.ModalTitle>

              <SC.ModalDescription>
                Existerande avtal är avtal som redan är signerade och klara och
                endast läggs in i systemet i administrationssyfte.
              </SC.ModalDescription>

              <SC.OptionsWrapper>
                <SC.Option onClick={() => onSelect("existing")}>
                  <SC.OptionIcon imgSrc={existingContractIcon} />
                  <SC.OptionLabel>Existerande avtal</SC.OptionLabel>
                </SC.Option>

                <SC.Option onClick={() => onSelect("new")}>
                  <SC.OptionIcon imgSrc={newContractIcon} />
                  <SC.OptionLabel>Nytt avtal</SC.OptionLabel>
                </SC.Option>

                {canClone && (
                  <SC.Option onClick={() => onSelect("clone")}>
                    <SC.OptionIcon imgSrc={copyIcon} />
                    <SC.OptionLabel>Kopia av avtal</SC.OptionLabel>
                  </SC.Option>
                )}
              </SC.OptionsWrapper>
            </SC.ModalContent>
          </SC.Modal>
        </SC.BackDrop>
      )
  );
}
